export default {
  data() {
    return {
      curGroupIndex: null, // tag分组的index
      curRouteName: null, // 组件名
      appScrollbar: null
    }
  },
  activated() {
    // key的名称应该是 this.$store.state.app.groupIndex + compName（组件名称）来记录
    const appScrollbarObject = this.$store.state.app.appScrollbarObject
    const key = this.curGroupIndex + this.curRouteName
    this.appScrollbar.scrollTo(0, appScrollbarObject[key] || 0)
  },
  deactivated() {
    this.appScrollbar.scrollTo(0, 0)
  },
  beforeRouteLeave(to, from, next) {
    if (!from.meta.noCache && to.meta.noCache) {
      // 从缓存页跳到非缓存页记录位置
      const key = this.curGroupIndex + this.curRouteName
      const position = this.appScrollbar && this.appScrollbar.scrollTop || 0
      this.$store.commit('SET_APP_SCROLLBAR', { key, value: position })
    }
    next()
  },
  mounted() {
    this.appScrollbar = document.getElementsByClassName('layout-scrollbar-wrapper')[0]
    this.curRouteName = this.$route && this.$route.name
    this.curGroupIndex = this.$store && this.$store.state.app.groupIndex
  }
}

